import { Alert, AppBar, Box, Button, Grid, Tab, Tabs } from '@mui/material'
import RegisterDeviceForm from './RegisterDevice/RegisterDeviceForm'
import {
    IRegisterDeviceForm,
    RegisterDeviceTab,
    TabPanel,
} from './RegisterDevicePage'
import { SelectClientContract } from 'models'
import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import usePermission from 'hooks/usePermission/usePermission'
import { ADMIN_ALL } from 'constant/permissions'
import { useMemo } from 'react'
import { useLogout } from 'pages/LogoutPage/LogoutPage'

function RegisterOrSelectDeviceTab({
    currentTab,
    handleChangeTab,
    clients,
    disabled,
    cancelable,
    handleCancel,
}: {
    currentTab: RegisterDeviceTab
    handleChangeTab: (event: React.SyntheticEvent, newValue: any) => void
    clients: SelectClientContract[]
    disabled: boolean
    cancelable: boolean
    handleCancel: () => void
}) {
    const { formState } = useFormContext<IRegisterDeviceForm>()
    const { t } = useTranslation()
    const { handleOnLogout } = useLogout()
    const { hasPermission } = usePermission()
    const tabOptions = useMemo(() => {
        const tabs = []
        if ((clients?.length ?? 0) > 0)
            tabs.push({
                value: RegisterDeviceTab.EXISTING,
                label: t('register_device.label.select_existing_client'),
            })

        if (hasPermission([ADMIN_ALL]))
            tabs.push({
                value: RegisterDeviceTab.REGISTER,
                label: t('register_device.label.register_new_device'),
            })
        return tabs
    }, [clients?.length, hasPermission, t])
    return (
        <Grid item container direction="column" spacing={2}>
            <Grid item>
                <AppBar position="static">
                    {tabOptions?.length > 0 ? (
                        <Tabs
                            data-testid="register_or_select_device_tab"
                            sx={{
                                [`& .MuiTabs-indicator`]: {
                                    backgroundColor:
                                        tabOptions.length > 1
                                            ? 'primary.contrastText'
                                            : 'primary.main',
                                    height: 4,
                                },
                            }}
                            value={currentTab}
                            onChange={handleChangeTab}
                            textColor="inherit"
                            variant="fullWidth"
                        >
                            {tabOptions.map((ta) => (
                                <Tab
                                    disabled={clients.length === 0}
                                    label={ta.label}
                                    value={ta.value}
                                />
                            ))}
                        </Tabs>
                    ) : (
                        <Alert severity="warning">
                            {t('register_device.label.require_super_user')}
                        </Alert>
                    )}
                </AppBar>
                {tabOptions.map((ta) => (
                    <TabPanel value={currentTab} index={ta.value}>
                        <RegisterDeviceForm
                            tab={currentTab}
                            clients={clients}
                        />
                    </TabPanel>
                ))}
            </Grid>
            <Grid item>
                <Box
                    display={'flex'}
                    justifyContent={'center'}
                    style={{ gap: 16 }}
                >
                    {cancelable && (
                        <Button
                            disabled={disabled}
                            type="button"
                            size={'large'}
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                    )}
                    {tabOptions.length > 0 ? (
                        <Button
                            color={'info'}
                            disabled={!formState.isValid || disabled}
                            type="submit"
                            size={'large'}
                        >
                            {t('register_device.label.submit')}
                        </Button>
                    ) : (
                        <Button onClick={handleOnLogout}>Logout</Button>
                    )}
                </Box>
            </Grid>
        </Grid>
    )
}
export default RegisterOrSelectDeviceTab
